<template>
  <a-menu v-model:selectedKeys="activeMenu" mode="horizontal">
    <template v-for="item in topMenus">
      <template v-if="hasOneShowingChild(item.children, item)">
        <a-menu-item :key="item.path">
          <div class="ant-menu-title">
            <app-link :to="item.path">
              <span>{{ item.meta.title }}</span>
            </app-link>
          </div>
        </a-menu-item>
      </template>

      <a-sub-menu v-else :key="item.path">
        <template #title>
          <span :key="item.path">
            <span>{{ item.meta.title }}</span>
          </span>
        </template>

        <a-menu-item v-for="child in item.children" :key="item.path + '/' + child.path">
          <div class="ant-menu-title">
            <app-link :to="item.path + '/' + child.path">
              <span>{{ child.meta.title }}</span>
            </app-link>
          </div>
        </a-menu-item>
      </a-sub-menu>
    </template>

    <!-- 顶部菜单超出数量折叠 -->
    <!-- <a-sub-menu :key="'more'" v-if="topMenus.length > visibleNumber">
      <template #title>更多菜单</template>
      <template v-for="(item, index) in topMenus">
        <a-menu-item
          :key="item.path"
          v-if="index >= visibleNumber"
        >
          <svg-icon :icon-class="item.meta.icon" />
          {{ item.meta.title }}
        </a-menu-item>
      </template>
    </a-sub-menu> -->
  </a-menu>
</template>

<script setup>
import { ref, computed, onMounted, onBeforeUnmount } from "vue";
import { useRoute, useRouter } from "vue-router";
import { constantRoutes } from "@/router";
import { isHttp } from "@/utils/validate";
import AppLink from "./Link";
import useAppStore from "@/store/modules/app";
import useSettingsStore from "@/store/modules/settings";
import usePermissionStore from "@/store/modules/permission";
import { isExternal } from "@/utils/validate";
const visibleNumber = ref(null);
// 当前激活菜单的 index
const currentIndex = ref(null);
const hideList = ["/index", "/user/profile"];
const appStore = useAppStore();
const settingsStore = useSettingsStore();
const permissionStore = usePermissionStore();
const route = useRoute();
const router = useRouter();
// 所有的路由信息
const routers = computed(() => permissionStore.topbarRouters);
// 顶部显示菜单
const topMenus = computed(() => {
  let topMenus = [];
  routers.value.map((menu) => {
    if (menu.hidden !== true) {
      // 兼容顶部栏一级菜单内部跳转
      if (menu.path === "/") {
        topMenus.push(menu.children[0]);
      } else {
        if (menu.children.length == 1) {
          topMenus.push({
            path: menu.path + "/" + menu.children[[0]].path,
            meta: menu.children[[0]].meta,
            hidden: menu.children[[0]].hidden,
          });
        } else {
          let arr = menu.children.filter((item) => item.hidden === false);
          if (arr.length == 1) {
            topMenus.push({
              path: menu.path + "/" + arr[0].path,
              meta: arr[0].meta,
              hidden: arr[0].hidden,
            });
          } else {
            topMenus.push({
              path: menu.path,
              meta: menu.meta,
              hidden: menu.hidden,
              children: arr,
            });
          }
        }
      }
    }
  });
  return topMenus;
});
// 设置子路由
const childrenMenus = computed(() => {
  let childrenMenus = [];
  routers.value.map((router) => {
    for (let item in router.children) {
      if (router.children[item].parentPath === undefined) {
        if (router.path === "/") {
          router.children[item].path = "/" + router.children[item].path;
        } else {
          if (!isHttp(router.children[item].path)) {
            router.children[item].path =
              router.path + "/" + router.children[item].path;
          }
        }
        router.children[item].parentPath = router.path;
      }
      childrenMenus.push(router.children[item]);
    }
  });
  return constantRoutes.concat(childrenMenus);
});
// 默认激活的菜单
const activeMenu = computed(() => {
  const path = route.path;
  let activePath = path.split("/");

  // 移除数组的第一个元素（空字符串）
  activePath.shift();

  // 为每个元素添加前缀 '/'
  activePath = activePath.map((item) => "/" + item);

  activePath.push(path);
  // return ['/enterpriseManage','/enterprise','/enterpriseManage/enterprise'];
  console.log("activePath", activePath);
  //测试管理中，实时监测模块 测试路线模块 因布局与其他页面不同，会重定向页面，为区分开，此处写死
  if (activePath.includes('/realtimeMonitorB')) {
    return ['/testManage', '/realtimeMonitorA', '/testManage/realtimeMonitorA']
  } else if (activePath.includes('/testPathB')) {
    return ['/testManage', '/testPathA', '/testManage/testPathA']
  }
  else {
    return activePath;
  }

});
function handleSelect(item, keyPath) {
  currentIndex.value = item.key;
}

const onlyOneChild = ref(null);
const hasOneShowingChild = (children = [], parent) => {
  const showingChildren = children.filter((item) => {
    if (item.hidden) {
      return false;
    } else {
      onlyOneChild.value = item;
      return true;
    }
  });

  // 当只有一个子路由时，默认显示该子路由
  if (showingChildren.length === 1) {
    return true;
  }

  // 如果没有子路由显示，则显示父路由
  if (showingChildren.length === 0) {
    onlyOneChild.value = { ...parent, path: "", noShowingChildren: true };
    return true;
  }

  return false;
};

const resolvePath = (routePath, routeQuery) => {
  if (isExternal(routePath)) {
    return routePath;
  }
};

function setVisibleNumber() {
  const width = document.body.getBoundingClientRect().width / 3;
  visibleNumber.value = parseInt(width / 85);
}

onMounted(() => {
  window.addEventListener("resize", setVisibleNumber);
});
onBeforeUnmount(() => {
  window.removeEventListener("resize", setVisibleNumber);
});
onMounted(() => {
  setVisibleNumber();
});
</script>

<style lang="scss">
.topmenu-container.el-menu--horizontal>.el-menu-item {
  float: left;
  height: 50px !important;
  line-height: 50px !important;
  color: #999093 !important;
  padding: 0 5px !important;
  margin: 0 10px !important;
}

.topmenu-container.el-menu--horizontal>.el-menu-item.is-active,
.el-menu--horizontal>.el-sub-menu.is-active .el-submenu__title {
  border-bottom: 2px solid #fff !important;
  color: #303133;
}

/* sub-menu item */
.topmenu-container.el-menu--horizontal>.el-sub-menu .el-sub-menu__title {
  float: left;
  height: 50px !important;
  line-height: 50px !important;
  color: #999093 !important;
  padding: 0 5px !important;
  margin: 0 10px !important;
}

/* 背景色隐藏 */
.topmenu-container.el-menu--horizontal>.el-menu-item:not(.is-disabled):focus,
.topmenu-container.el-menu--horizontal>.el-menu-item:not(.is-disabled):hover,
.topmenu-container.el-menu--horizontal>.el-submenu .el-submenu__title:hover {
  background-color: #ffffff !important;
}

/* 图标右间距 */
.topmenu-container .svg-icon {
  margin-right: 4px;
}

/* topmenu more arrow */
.topmenu-container .el-sub-menu .el-sub-menu__icon-arrow {
  position: static;
  vertical-align: middle;
  margin-left: 8px;
  margin-top: 0px;
}

.ant-menu-item-selected {
  color: #ffffff !important;
}

.ant-menu-horizontal>.ant-menu-item-selected::after {
  width: 30% !important;
  left: 35% !important;
  border-color: #fff !important;
}

.ant-menu-horizontal .ant-menu-submenu :hover {
  color: #ffffff !important;

  &::after {
    border-color: #fff !important;
    width: 30% !important;
    left: 35% !important;
  }
}

.ant-menu-horizontal>.ant-menu-item::after,
.ant-menu-horizontal>.ant-menu-submenu::after {
  width: 30% !important;
  left: 35% !important;
}

.ant-menu-light.ant-menu-horizontal>.ant-menu-submenu:hover::after {
  border-color: #fff !important;
}

.ant-menu-light .ant-menu-item:hover:not(.ant-menu-item-selected):not(.ant-menu-submenu-selected),
.ant-menu-light .ant-menu-submenu-title:hover:not(.ant-menu-item-selected):not(.ant-menu-submenu-selected) {
  color: #ffffff !important;
}

.ant-menu-light.ant-menu-horizontal>.ant-menu-item:hover::after,
.ant-menu-light.ant-menu-horizontal>.ant-menu-submenu:hover::after,
.ant-menu-light.ant-menu-horizontal>.ant-menu-item-active::after,
.ant-menu-light.ant-menu-horizontal>.ant-menu-submenu-active::after,
.ant-menu-light.ant-menu-horizontal>.ant-menu-item-open::after,
.ant-menu-light.ant-menu-horizontal>.ant-menu-submenu-open::after {
  border-color: #fff !important;
}

.ant-menu-light.ant-menu-horizontal>.ant-menu-item-selected,
.ant-menu-light.ant-menu-horizontal>.ant-menu-submenu-selected {
  color: #ffffff !important;
}

.ant-menu-light .ant-menu-submenu-selected>.ant-menu-submenu-title {
  color: #ffffff !important;
}

.ant-menu-light.ant-menu-horizontal>.ant-menu-item-selected::after,
.ant-menu-light.ant-menu-horizontal>.ant-menu-submenu-selected::after {
  border-color: #fff !important;
  width: 30% !important;
  left: 35% !important;
}

.ant-menu-submenu-popup .ant-menu-vertical.ant-menu-sub {
  min-width: 106px;
}

.ant-menu-light:not(.ant-menu-horizontal) .ant-menu-item:not(.ant-menu-item-selected):active {
  background: transparent !important;
}

.ant-menu-light .ant-menu-item-selected {
  background: transparent !important;
}

.ant-menu-sub .ant-menu-item:hover:not(.ant-menu-item-selected):not(.ant-menu-submenu-selected),
.ant-menu-sub .ant-menu-submenu-title:hover:not(.ant-menu-item-selected):not(.ant-menu-submenu-selected) {
  color: #186ff2 !important;
}

.ant-menu-sub .ant-menu-item-only-child {
  color: #1d2129 !important;
}

.ant-menu-sub .ant-menu-item-selected {
  color: #186ff2 !important;
}
</style>
